/**
 * Soccer :: Perform :: API 1.0.0
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class CompetitionsApi extends runtime.BaseAPI {
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-calendars.htm\">Perform Documentation - OT2</a>
     * Returns the OT2 feed
     */
    async performSoccerdataCompetitionsCompetitionIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.competitionId === null ||
            requestParameters.competitionId === undefined) {
            throw new runtime.RequiredError('competitionId', 'Required parameter requestParameters.competitionId was null or undefined when calling performSoccerdataCompetitionsCompetitionIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/competitions/{competitionId}`.replace(`{${'competitionId'}}`, String(requestParameters.competitionId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-calendars.htm\">Perform Documentation - OT2</a>
     * Returns the OT2 feed
     */
    async performSoccerdataCompetitionsCompetitionIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataCompetitionsCompetitionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-calendars.htm\">Perform Documentation - OT2</a>
     * Returns a snapshot of the OT2 feed
     */
    async performSoccerdataCompetitionsCompetitionIdSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.competitionId === null ||
            requestParameters.competitionId === undefined) {
            throw new runtime.RequiredError('competitionId', 'Required parameter requestParameters.competitionId was null or undefined when calling performSoccerdataCompetitionsCompetitionIdSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataCompetitionsCompetitionIdSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/competitions/{competitionId}/snapshots/{snapshotId}`
                .replace(`{${'competitionId'}}`, String(requestParameters.competitionId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-calendars.htm\">Perform Documentation - OT2</a>
     * Returns a snapshot of the OT2 feed
     */
    async performSoccerdataCompetitionsCompetitionIdSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataCompetitionsCompetitionIdSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-trophies.htm\">Perform Documentation - TM8</a>
     * Returns the TM8 feed
     */
    async performSoccerdataCompetitionsCompetitionIdTrophiesGetRaw(requestParameters, initOverrides) {
        if (requestParameters.competitionId === null ||
            requestParameters.competitionId === undefined) {
            throw new runtime.RequiredError('competitionId', 'Required parameter requestParameters.competitionId was null or undefined when calling performSoccerdataCompetitionsCompetitionIdTrophiesGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/competitions/{competitionId}/trophies`.replace(`{${'competitionId'}}`, String(requestParameters.competitionId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-trophies.htm\">Perform Documentation - TM8</a>
     * Returns the TM8 feed
     */
    async performSoccerdataCompetitionsCompetitionIdTrophiesGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataCompetitionsCompetitionIdTrophiesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-trophies.htm\">Perform Documentation - TM8</a>
     * Returns a snapshot of the TM8 feed
     */
    async performSoccerdataCompetitionsCompetitionIdTrophiesSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.competitionId === null ||
            requestParameters.competitionId === undefined) {
            throw new runtime.RequiredError('competitionId', 'Required parameter requestParameters.competitionId was null or undefined when calling performSoccerdataCompetitionsCompetitionIdTrophiesSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataCompetitionsCompetitionIdTrophiesSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/competitions/{competitionId}/trophies/snapshots/{snapshotId}`
                .replace(`{${'competitionId'}}`, String(requestParameters.competitionId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-trophies.htm\">Perform Documentation - TM8</a>
     * Returns a snapshot of the TM8 feed
     */
    async performSoccerdataCompetitionsCompetitionIdTrophiesSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataCompetitionsCompetitionIdTrophiesSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-calendars.htm\">Perform Documentation - OT2</a>
     * Returns the OT2 feed [NO SNAPSHOT LAYER]
     */
    async performSoccerdataCompetitionsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }
        if (requestParameters.authorized !== undefined) {
            queryParameters['authorized'] = requestParameters.authorized;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/competitions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-tournament-calendars.htm\">Perform Documentation - OT2</a>
     * Returns the OT2 feed [NO SNAPSHOT LAYER]
     */
    async performSoccerdataCompetitionsGet(requestParameters = {}, initOverrides) {
        const response = await this.performSoccerdataCompetitionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=CompetitionsApi.js.map